import React from "react";

import { Box, Typography, useMediaQuery, makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import PageSection from "components/landing/PageSection";

const useStyles = makeStyles((theme) => ({
    imageRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(4),
        [theme.breakpoints.down('md')]: {
            flexWrap: "wrap"
        },
        [theme.breakpoints.up('md')]: {
            flexWrap: "nowrap"
        }
    },
    imageContainer: {
        "flex-shrink": 1,
        [theme.breakpoints.down('md')]: {
            flexBasis: `calc((100% - ${theme.spacing(4)}px) / 2)`
        },
        [theme.breakpoints.up('md')]: {
            flexBasis: 0
        }
    },
    image: {
        width: "100%"
    }
}));

const TrustedBy: React.FC = () => {
    const theme = useTheme();
    const classes = useStyles();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const logos = [{
        image: "/content/landing/home/trusted-by/co-op.png",
        alt: "co-op logo",
        ratio: 1.25
    }, {
        image: "/content/landing/home/trusted-by/british-heart-foundation.jpg",
        alt: "british heart foundation logo",
        ratio: 3
    }, {
        image: "/content/landing/home/trusted-by/white-stuff.png",
        alt: "white stuff logo",
        ratio: 3
    }, {
        image: "/content/landing/home/trusted-by/matalan.png",
        alt: "matalan logo",
        ratio: 4
    }, {
        image: "/content/landing/home/trusted-by/whittard.png",
        alt: "whittard logo",
        ratio: 1.25
    }, {
        image: "/content/landing/home/trusted-by/cotswold.png",
        alt: "cotswold logo",
        ratio: 2.25
    }];

    return (
        // @ts-ignore
        <PageSection
            bgcolor={theme.palette.common.white}
            dataCy="pages-landing-home-trusted-by"
        >
            <Typography variant={isMobile ? "h4" : "h2"} component="div" align="center" gutterBottom>
                Trusted by
            </Typography>
            <br />
            <br />

            <Box className={classes.imageRow }>
                {logos.map((logo, index) =>
                    <Box className={classes.imageContainer} style={{flexGrow: logo.ratio}}>
                        <img key={index} src={logo.image} alt={logo.alt} className={classes.image} />
                    </Box>
                )}
            </Box>
        </PageSection>
    );
};

export default TrustedBy;
